import SwiperCore, { Navigation } from 'swiper';
import { Swiper } from 'swiper/react';
import '/node_modules/swiper/swiper-bundle.css';
import { ForwardedRef } from 'react';
import { styled } from 'styled-components';

// 安装所需的 Swiper 组件
SwiperCore.use([Navigation]);

interface IProps {
  children: React.ReactNode;
  navigation?: {
    nextEl: string;
    prevEl: string;
  };
  style?: React.CSSProperties;
  onChange?: (prevInx: number, inx: number) => void;
}

const SwiperWrap = styled.div`
  width: 100%;
  height: 100%;
  .swiper-wrapper {
    width: 100%;
    height: 100%;
  }
`;

const SwiperComp = forwardRef((props: IProps, ref: ForwardedRef<any>) => {
  const navigation = props.navigation || {
    nextEl: '.slide-arrow.right',
    prevEl: '.slide-arrow.left',
  };

  const swiperObj = useRef<any>(null);

  const handleSlide = (page: number) => {
    swiperObj.current.slideTo(page);
  };

  useImperativeHandle<any, any>(ref, () => ({
    swiperObj,
    handleSlide,
  }));

  return (
    <SwiperWrap>
      <Swiper
        onSwiper={(Swiper) => (swiperObj.current = Swiper)}
        onSlideChangeTransitionEnd={(e) => props?.onChange?.(e.previousIndex, e.activeIndex)}
        style={{ ...props.style }}
        loop={false}
        navigation={navigation}
      >
        {props.children}
      </Swiper>
    </SwiperWrap>
  );
});

export default SwiperComp;
